import React, { Suspense, useEffect, useState } from "react";
import { Layout, Menu, Spin, Row, Col, Space, Avatar, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import Sidebar from "parts/Sidebar";
import Header from "parts/Header";
import "./index.less";

import NotFound from "pages/404";
import Forbidden from "pages/403";
import routes from "routes";
import apiAuth from "constants/api/apiAuth";
import util from "helpers/util";

const { Content, Footer } = Layout;
const { Text } = Typography;

const PrivateLayout = () => {
  const [menu, setMenu] = useState({
    //allRoutes: [],
    allowedMenus: []
  });
  const [checkAuthorize, setCheckAuthorize] = useState(false);

  useEffect(() => {
    //apiAuth.getAccess().then((res1) => {
    apiAuth.getMenu().then((res2) => {
      setMenu({
        //allRoutes: res1,
        allowedMenus: res2.result
      });

    }).catch((err) => { });
    //}).catch((err) => { });
  }, []);

  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[1];

    apiAuth.checkAuthorization(path).then(res => {
      setCheckAuthorize(res.success);
    })
  }, [location]);

  const urlDetail = util.getCurrentUrlDetail();

  return (
    <Layout>
      <Sidebar allowedMenus={menu.allowedMenus} />
      <Layout className="site-layout" style={{ flex:"1", minHeight:"100vh" }}>
        <Header />
        <Content
          style={{
            margin: "80px 16px 0",
            overflow: "initial",
          }}
        >
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 400 }}
          >
            <Suspense
              fallback={
                <Row
                  style={{
                    padding: 4,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Col>
                    <Spin size="middle" tip="Loading..."></Spin>
                  </Col>
                </Row>
              }
            >
              <Switch>
                {routes.map((r) => {
                  const authorized = (util.isInMenu(menu.allowedMenus, urlDetail.path) && checkAuthorize) || urlDetail.path === 'home';
                  const component = authorized ? r.component : Forbidden;

                  return (
                    <Route
                      key={r.id}
                      path={r.path}
                      component={component}
                      exact={!!r.exact}
                    />
                  );
                })}
                <Route exact path="/">
                  <Redirect to="/home" />
                </Route>
                <Route component={NotFound} />
              </Switch>
            </Suspense>
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          © Matahari Department Store, 2021
        </Footer>
      </Layout>
    </Layout>
  );
};

export default PrivateLayout;
